import { createContext, useContext } from "react";

import { TemplateManagementFormModel } from "./TemplateManagementFormModel.ts";

export const TemplateManagerFormContext =
  createContext<TemplateManagementFormModel>({} as TemplateManagementFormModel);

export const useTemplateManagerFormContext = () =>
  useContext(TemplateManagerFormContext);
